/**
 * /api/v1/DispatchBoard — cross-entity composite reads + bulk ops.
 * The Day view is THE call — one round trip loads everything.
 */

import axios from 'axios';
import config from '../../../../../config';
import { unwrap } from '../http';
import type {
  BackendDispatchBoardDay,
  CaptureSummary,
  CreateUpdateResponse,
} from '../types';

const BASE = `${config.api.API_URL}/DispatchBoard`;

export const dispatchBoardService = {
  /**
   * One-call composite — crews (with members + assets + activities) +
   * standalone activities + unplanned-tasks rail. Use this for the day
   * view; don't piece together from individual endpoints.
   */
  getDay: (date: string) =>
    axios
      .get<BackendDispatchBoardDay>(`${BASE}/day`, { params: { date } })
      .then(unwrap),

  /** Clone source-date crews + members + assets into target date. Refuses if target already has crews. */
  copyDay: (sourceDate: string, targetDate: string) =>
    axios
      .post<CreateUpdateResponse<number>>(`${BASE}/copy-day`, null, {
        params: { sourceDate, targetDate },
      })
      .then(unwrap),

  /** Bulk-deactivate one user's worker rows across every activity scheduled on the date. */
  markStaffAway: (userId: string, date: string) =>
    axios
      .post<CreateUpdateResponse<number>>(`${BASE}/mark-away`, null, {
        params: { userId, date },
      })
      .then(unwrap),

  /** End-of-day capture status per activity — drives the admin's "Save Capture" screen. */
  getCaptureSummary: (date: string) =>
    axios
      .get<CaptureSummary>(`${BASE}/capture-summary`, { params: { date } })
      .then(unwrap),
};
